<!--Outbound>Resource Planning-->
<template>
    <div class="mains">
        <!--Header列表-->
        <a-row>
            <div ref="refTopHeight">
                <a-row style="border: 1px solid #e8eaec;">
                    <a-col>
                        <a-button type="primary" size="small" class="mg5" @click="query">{{$t('job.Query')}}</a-button>
                        <a-button type="primary" size="small" class="mg5" @click="reset">{{ $t('job.Reset') }}</a-button>
                        <a-button type="primary" size="small" class="mg5" @click="create">{{ $t('login.Create') }}</a-button>
                    </a-col>
                </a-row>
                <a-row>
                    <a-form :form="formQuery" style="margin: 0 0 5px 5px;">
                        <a-row>
                            <a-col span="2">
                                <a-form-item class="genericFrom">
                                    <b>Plan Id:</b><br>
                                    <a-input @pressEnter="query" size="small" v-decorator="['resPlanId']"/>
                                </a-form-item>
                            </a-col>
                            <a-col span="2" offset="1">
                                <a-form-item class="genericFrom">
                                    <b>Wave Id:</b><br>
                                    <a-input @pressEnter="query" size="small" v-decorator="['waveId']"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-form>
                </a-row>
                <a-row style="border: 1px solid #e8eaec;">
                    <a-col span="10">
                        <a-button type="primary" size="small" class="mg5" @click="deleteHeader">{{$t('job.Delete')}}</a-button>
                    </a-col>
                    <a-col offset="10" align="right" style="padding-top: 5px;">
                        <!--分页-->
                        <a-pagination
                                :pageSizeOptions="pageSizeOptions"
                                :showTotal="total => $t('job.Total') + ` ${pagingTotal} `+$t('job.Records')"
                                size="small"
                                :total="pagingTotal"
                                v-model="currentVal"
                                :pageSize.sync="pagingSize"
                                @change="tableChangePage"
                                @showSizeChange="onShowSizeChange"
                                :showSizeChanger="showSizeChanger"
                                :showQuickJumper="showQuickJumper"
                        />
                    </a-col>
                </a-row>
                <a-row>
                    <!--列表-->
                    <vxe-table
                            border
                            resizable
                            stripe
                            column-key
                            highlight-hover-column
                            highlight-hover-row
                            highlightCurrentRow
                            show-header-overflow
                            show-overflow
                            :sort-config="{multiple: true, trigger: 'cell'}"
                            :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                            keep-source
                            @cell-dblclick="headerDoubleClick"
                            @cell-click="headerClick"
                            align="center"
                            :data.sync="pagingGridList"
                            :height="getTopHeight"
                            ref="refHeaderPagingGrid"
                            size="mini">
                        <template v-slot:empty>
                            <a-empty></a-empty>
                        </template>
                        <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                        <vxe-table-column type="uid" :visible="false"></vxe-table-column>
                        <vxe-table-column field="orgCode" title="Org Code" ></vxe-table-column>
                        <vxe-table-column field="projectCode" title="Project Code" ></vxe-table-column>
                        <vxe-table-column field="resPlanId" title="Plan Id" ></vxe-table-column>
                        <vxe-table-column field="waveId" title="Wave Id"  sortable></vxe-table-column>
                        <vxe-table-column field="status" title="Status"  sortable>
                            <template v-slot="{ row }">{{row.status|filterSatus}}</template>
                        </vxe-table-column>
                        <vxe-table-column field="resPlanDate" title="Plan Date" :formatter="formatDate" sortable></vxe-table-column>
                        <vxe-table-column field="actCompDate" title="Act Comp Dat" :formatter="formatDate" sortable></vxe-table-column>
                        <vxe-table-column field="startDate" title="Start Date" :formatter="formatDate" sortable></vxe-table-column>
                        <vxe-table-column field="estCompDate" title="Est Comp Date" :formatter="formatDate" sortable></vxe-table-column>
                        <vxe-table-column field="remark" :title="$t('job.Remark')" sortable></vxe-table-column>
                        <vxe-table-column field="creator" title="Creator" sortable ></vxe-table-column>
                        <vxe-table-column field="createTime" title="Create Time" :formatter="formatTime" sortable ></vxe-table-column>
                        <vxe-table-column field="modifier" title="Modifier" sortable ></vxe-table-column>
                        <vxe-table-column field="modifyTime" title="Modify Time" :formatter="formatTime" sortable ></vxe-table-column>
                    </vxe-table>
                </a-row>
            </div>
        </a-row>
        <!--明细列表-->
        <a-row>
            <a-row style="border: 1px solid #e8eaec;">
                <a-col span="10">
                    <a-button type="primary" size="small" class="mg5" @click="saveDetail">{{$t('job.Save')}}</a-button>
                </a-col>
            </a-row>
            <a-row>
                <!--列表-->
                <vxe-table
                        border
                        resizable
                        stripe
                        column-key
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                        :sort-config="{multiple: true, trigger: 'cell'}"
                        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                        keep-source
                        align="center"
                        :data.sync="pagingGridDetailList"
                        class="mytable-style "
                        :height="bottomTableHeight"
                        ref="refDetailPagingGrid"
                        size="mini">
                    <template v-slot:empty>
                        <a-empty></a-empty>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column field="uid" title="UID" show-header-overflow="ellipsis" show-overflow="title" :visible="false"></vxe-table-column>
                    <vxe-table-column field="lineNo" title="Line No" show-header-overflow="ellipsis" show-overflow="title" :visible="false"></vxe-table-column>
                    <vxe-table-column field="taskCode" title="Task Code" sortable></vxe-table-column>
                    <vxe-table-column field="description" title="Description" sortable></vxe-table-column>
                    <vxe-table-column field="productity" title="Productity" sortable></vxe-table-column>
                    <vxe-table-column field="numOfPc" title="Num Of Pc" sortable></vxe-table-column>
                    <vxe-table-column field="prodLine" title="Prod Line" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                    <vxe-table-column field="estWorker" title="Est Worker" sortable></vxe-table-column>
                    <vxe-table-column field="actWorker" title="Act Worker" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                    <vxe-table-column field="estTimeReq" title="Est Time Req" sortable></vxe-table-column>
                    <vxe-table-column field="creator" title="Creator" sortable ></vxe-table-column>
                    <vxe-table-column field="createTime" title="Create Time" :formatter="formatTime" sortable ></vxe-table-column>
                    <vxe-table-column field="modifier" title="Modifier" sortable ></vxe-table-column>
                    <vxe-table-column field="modifyTime" title="Modify Time" :formatter="formatTime" sortable ></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-row>

        <!--弹出Header修改窗口-->
        <a-modal :title="this.headerData.resPlanId" v-model="showHeader" width="50%" :maskClosable="false">
            <a-form :form="formHeader">
                <a-row>
                    <a-form-item class="genericFrom">
                        <a-col :span = "7" offset="1" align="right">
                            <b>Act Comp Date</b>
                        </a-col>
                        <a-col :span = "10" offset="1">
                            <a-date-picker size="small" format="YYYY-MM-DD" v-decorator="['actCompDate',{initialValue: this.headerData == null ? '' : this.headerData.actCompDate}]"/>
                        </a-col>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item  class="genericFrom">
                        <a-col :span = "7" offset="1" align="right">
                            <b>Start Date</b>
                        </a-col>
                        <a-col :span = "10" offset="1">
                            <a-date-picker size="small" format="YYYY-MM-DD" v-decorator="['startDate',{initialValue: this.headerData == null ? '' : this.headerData.startDate}]"/>
                        </a-col>
                    </a-form-item>
                </a-row>
                <a-row>
                    <a-form-item  class="genericFrom">
                        <a-col :span = "7" offset="1" align="right">
                            <b>Remark</b>
                        </a-col>
                        <a-col :span = "10" offset="1">
                            <a-textarea size="small" v-decorator="['remark',{initialValue: this.headerData == null ? '' : this.headerData.remark}]"/>
                        </a-col>
                    </a-form-item>
                </a-row>
            </a-form>
            <template slot="footer">
                <a-button type="danger" @click="clearHeader">{{ $t('job.Reset') }}</a-button>
                <a-button type="primary" @click="saveHeader">{{ $t('publicLang.Save') }}</a-button>
            </template>
        </a-modal>

        <!--弹出Create窗口-->
        <a-modal :title="$t('login.Create')" v-model="showCreate" width="50%" :maskClosable="false" :zIndex="98" @cancel="clearCreateData">
            <a-form :form="formCreate">
                <a-row>
                    <a-form-item class="genericFrom">
                        <a-col :span = "7" offset="1" align="right">
                            <b>{{$t('pubGicSet.WaveID')}}<span style="color: red">*</span></b>
                        </a-col>
                        <a-col :span = "10" offset="1">
                            <a-input-search size="small" @search="searchWave" v-decorator="[
                                                                        'waveId',
                                                                        {
                                                                            initialValue: this.createData == null ? '' : this.createData.waveId,
                                                                            rules: [
                                                                                {
                                                                                  required: true,
                                                                                  message: $t('publicLang.Required'),
                                                                                }
                                                                            ]
                                                                        }]"/>
                        </a-col>
                    </a-form-item>
                </a-row>
            </a-form>
            <template slot="footer">
                <a-button type="primary" @click="addData">{{ $t('login.Create') }}</a-button>
            </template>
        </a-modal>

        <!--WaveId弹出窗-->
        <search-wave ref="queryWindow" @checkedCode="checkedCode"></search-wave>
    </div>
</template>

<script>
    import ajax from "../../api/ajax";
    import api from "../../api/url";
    import moment from "moment";
    import XEUtils from "xe-utils";
    import searchWave from "./components/searchWave";

    export default {
        components:{
            searchWave
        },
        data() {
            return {
                pagingTotal: 0, // 总数
                pagingSize: 20, // 条数
                currentVal: 1, // 当前选中的页数
                showSizeChanger:true,//是否显示页码下拉框
                showQuickJumper:false,//是否显示快速跳转输入框
                pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                pagingGridList: [],//列表数据
                pagingGridDetailList: [],//列表数据
                formQuery: this.$form.createForm(this, {}),
                formHeader: this.$form.createForm(this, {}),
                formCreate: this.$form.createForm(this, {}),
                topTopHeight: 0,
                bottomTableHeight:330,
                showHeader:false,//是否显示Header修改弹出窗
                showCreate:false,//是否显示Create弹出窗
                headerData:{},
                createData:{},
                resPlanId:'',
            }
        },
        created() {
            this.query();
        },
        mounted() {
            this.topTopHeight = this.$refs.refTopHeight.clientHeight;//左侧列表上部份div的高度
        },
        computed:{
            getTopHeight(){
                return document.body.clientHeight - this.topTopHeight - this.bottomTableHeight - 10;//自适应查询列表的高度
            },
        },
        filters: {
            filterSatus(val) {
                let data = JSON.parse(sessionStorage.getItem('localData'))
                data = data.RES_PLAN_STATUS
                for(let i in data){
                    if(val == data[i].CODE){
                        return data[i].CODE_DESC
                    }
                }
            }
        },
        methods:{
            formatDate ({cellValue}) {
                return XEUtils.toDateString(cellValue, 'yyyy-MM-dd')
            },
            formatTime ({cellValue}) {
                return XEUtils.toDateString(cellValue, 'yyyy-MM-dd HH:mm:ss')
            },
            query(){
                this.formQuery.validateFields((err, values) => {
                    if (err) {
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if (values) {
                        let params = {//配置查询条件
                            resPlanId : values.resPlanId,
                            waveId : values.waveId,
                            currentVal : this.currentVal,
                            pagingSize : this.pagingSize,
                        }
                        ajax.post(api.GETRESPLANHEADERLIST,params).then(res=>{
                            if(res.code == 200){
                                this.pagingGridList = res.data;//列表
                                this.pagingTotal = res.total;
                                this.pagingGridDetailList = null;
                            }
                        })
                    }
                });
            },
            reset(){
                this.formQuery.resetFields();
            },
            clearHeader(){
                this.formHeader.resetFields();
            },
            tableChangePage(current) {
                this.currentVal = current;
                this.query();
            },
            onShowSizeChange(current, pageSize) {//选择下拉框后触发事件
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.query();
            },
            headerClick({ row }){
                this.resPlanId = row.resPlanId
                this.getDetailList(row.resPlanId);
            },
            getDetailList(resPlanId){
                var that = this
                clearTimeout(this.time)
                that.time = setTimeout(() =>{
                    let params = {//配置查询条件
                        resPlanId : resPlanId,
                    }
                    ajax.post(api.GETRESPLANDETAILLIST,params).then(res=>{
                        if(res.code == 200){
                            this.pagingGridDetailList = res.data;//列表
                        }
                    })
                },300)
            },
            headerDoubleClick({ row }){
                clearTimeout(this.time)
                this.showHeader = true;
                this.headerData = row;
                this.formHeader.setFieldsValue({
                    actCompDate: this.headerData.actCompDate,
                    // estCompDate: this.headerData.estCompDate,
                    startDate: this.headerData.startDate,
                    remark: this.headerData.remark
                });
            },
            saveHeader(){
                this.formHeader.validateFields((err, values) => {
                    if(err){
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if(values){
                        values.uid = this.headerData.uid
                        values.actCompDate = values.actCompDate == null ? null : moment(values.actCompDate).format('YYYY-MM-DD')
                        values.startDate = values.startDate == null ? null : moment(values.startDate).format('YYYY-MM-DD')
                        ajax.post(api.SAVERESPLANHEADER, values).then(res => {
                            if (res.code == 200) {
                                this.$message.success('Success submit')
                                this.query()
                                this.showHeader = false;
                            } else {
                                this.$customMessage.warning(res.msg,2);
                            }
                        })
                    }
                });
            },
            saveDetail(){
                let Records = this.$refs.refDetailPagingGrid.getRecordset();
                let updateRecords = Records.updateRecords
                let params = {
                    updateRecords : updateRecords
                }
                ajax.post(api.SAVERESPLANDETAIL, params).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg,2)
                        this.query();
                        this.getDetailList(this.resPlanId);
                    } else {
                        this.$customMessage.warning(res.msg,2);
                    }
                })
            },
            create(){
                this.showCreate = true;
            },
            searchWave(){
                let waveId = ''
                this.formCreate.validateFields((err, values) => {
                    if(values){
                        waveId = values.waveId
                    }
                });
                this.$refs.queryWindow.show(waveId)
            },
            checkedCode(row) {
                let name = ''
                if(row != null){
                    name = row.waveId
                }
                this.createData.waveId = name;
                this.formCreate.setFieldsValue({
                    waveId: name//实际值
                });
            },
            clearCreateData(){
                this.formCreate.resetFields();
                this.createData = {};
            },
            addData(){
                if(this.createData == null || this.createData.waveId == null || this.createData.waveId == undefined){
                    this.$customMessage.warning("Wave Id " + this.$t('job.notNull'),2);
                    return;
                }
                let params = {
                    waveId : this.createData.waveId
                }
                ajax.post(api.CREATERESPLANDATA,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success('Success submit')
                        this.clearCreateData();
                        this.showCreate = false;
                        this.query();
                    }else{
                        this.$customMessage.warning(res.msg,2);
                    }
                })
            },
            deleteHeader(){
                let Records = this.$refs.refHeaderPagingGrid.getCheckboxRecords()
                if(Records.length == 0){
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
                    return;
                }
                let idList = [];
                for(let i in Records){
                    idList.push(Records[i].resPlanId)
                }
                let that = this;
                this.$customConfirm({
                    title: that.$t('pubGicSet.AreyoudeleTask'),
                    okText: that.$t('publicLang.Confirm'),
                    cancelText: that.$t('publicLang.Cancel'),
                    content: "",
                    onOk() {
                        let params = new FormData();
                        params.append("idList", idList);
                        ajax.post(api.DELETERESPLANHEADER, params).then(res => {
                            if (res.code == 200) {
                                that.query()
                                that.$message.success(that.$t("publicLang.DeleteSuccess"));
                            } else {
                                that.$customMessage.error(res.msg);
                            }
                        })
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .mains{
        height: 100%;
        width: 100%;
        background-color: white;
        float: left;
    }
    .btn{
        margin: 5px;
    }
</style>